var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid person" }, [
      _c(
        "div",
        {
          staticClass:
            "grid__col--1 modal-people__icon-container h-center-align h-no-padding"
        },
        [
          _c("span", {
            staticClass:
              "glyphicon glyphicon-user queue-detail__glyph modal-people__icon modal-people__icon--blank",
            attrs: { "aria-hidden": "true" }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "grid__col--11 h-no-padding h-no-margin modal-people__text-container"
        },
        [
          _c("div", {
            staticClass:
              "modal-people__author modal-people__author--blank modal-people--blank"
          })
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }